import React, { useState, useCallback } from "react";

import queryString from "query-string";

import ReportService from "../../../services/reportService";

import SalesPerformanceFilters from "./SalesPerformanceFilters";

import SalesPerformancePageList from "./SalesPerformancePageList";

const SalesPerformancePage = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setData([]);
    const query = queryString.stringify(filters, { arrayFormat: "bracket" });
    const result = await ReportService.get(`/sales-performance?${query}`);
    setData(result);
    setLoading(false);
  }, [filters]);

  const handleChange = (name) => (value) => {
    setLoading(false);
    if (
      Array.isArray(value) &&
      (name === "customers" || name === "callTypes" || name === "projects")
    ) {
      setFilters((prev) => ({ ...prev, [name]: value.map((v) => v.value) }));
    } else {
      setFilters((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleResetFilters = () => {
    setFilters({});
    setData([]);
  };

  return (
    <div className="report-page">
      <SalesPerformanceFilters
        filters={filters}
        onChange={handleChange}
        fetchData={fetchData}
        handleResetFilters={handleResetFilters}
        exportDisabled={loading || !data?.length}
        loading={loading}
      />
      <SalesPerformancePageList data={data} loading={loading} />
    </div>
  );
};

export default SalesPerformancePage;
